import {NgModule, StaticProvider} from '@angular/core';
import {BrowserModule} from "@angular/platform-browser";
import {platformBrowserDynamic} from "@angular/platform-browser-dynamic";
import {downgradeModule} from "@angular/upgrade/static";
import {ScrollingModule} from "@angular/cdk/scrolling";
import {CommonsModule} from "../../commons/angular/commons.module";
import {TranslateModule} from "@ngx-translate/core";
import {NgbModule} from "@ng-bootstrap/ng-bootstrap";
import {NgxPermissionsModule} from "ngx-permissions";
import {GoogleMapsModule} from "@angular/google-maps";
import {AgentsMapComponent} from "./components/agents-map/agents-map.component";

@NgModule({
  declarations: [
    AgentsMapComponent
  ],
  imports: [
    BrowserModule,
    ScrollingModule,
    CommonsModule,
    NgbModule,
    GoogleMapsModule,
    TranslateModule.forChild(),
    NgxPermissionsModule.forChild()
  ],
  providers: [],
  exports: [
    AgentsMapComponent
  ]
})

export class MapModule {
  constructor() {
  }

  ngDoBootstrap() {
  }
}

const bootstrapMapModule = (extraProviders: StaticProvider[]) => {
  const platformRef = platformBrowserDynamic(extraProviders);
  return platformRef.bootstrapModule(MapModule);
};

export const downgradedMapModule = downgradeModule(bootstrapMapModule);
